import * as React from 'react';

import { DeprecatedReactActionsMenu, DeprecatedReactActionsMenuPanel } from '../../common/react/components/ActionsMenu';
import { DeprecatedReactMenu } from '../../common/react/components/Menu';

const SubplaceActionsMenuStyle: React.CSSProperties = {
  top: 22 // tb-popup-menu-text-button height + top/bottom margins (from popupMenu.styl) - 1px menu panel border
};

/**
 * The SubplaceActionsMenu is a wrapper around the ActionsMenu component that includes the proper
 * styling for the menu to be in the action bar for a subplace, right above the data grid.
 * When we have spotlight actions for subplaces (TFS 392338), the styling for this menu button will
 * change to match the normal ActionsMenu, and we may even be able to merge the
 * two implementations.
 */
export function SubplaceActionsMenu<S, D>(props: DeprecatedReactActionsMenu.Props<S, D>) {
  // We would instantiate the ActionsMenu component here, except we're currently using a different
  // menu button design. So instead, we re-implement the render() method of the ActionsMenu
  // component, with a different menu button factory.
  return DeprecatedReactMenu.element({
    menuButtonFactory: () => (
      <div className="tb-popup-menu-text-button tb-small" data-tb-test-id="action-menu-button">
        <span className="tb-arrow" />
        <span className="tb-content">{ props.translate('actions') }</span>
      </div>
    ),
    menuPanelFactory: DeprecatedReactActionsMenuPanel(props),
    style: props.style,
    menuPanelStyle: SubplaceActionsMenuStyle,
    tbTestId: 'action-menu'
  });
}
